import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { NoveltyCheckTaskStatus } from '../types';

/**
 * 专利新颖性检查任务状态模型
 * @description 存储专利新颖性检查任务状态
 */
export interface NoveltyCheckTaskStatusModel extends Model<NoveltyCheckTaskStatus>, Disposable {

}

export const NoveltyCheckTaskStatusModel = Symbol.for('NoveltyCheckTaskStatusModel');
